import React, { Component } from 'react'
import formatPrice from '../func/formatPrice';
import TextValueField from '../general/TextValueField';
import EditEventFormTypeWrapper from './EditEventFormTypeWrapper';


class EditEventFormPriceType extends Component {
    constructor(props) {
        super(props);

        this.state = {
            edit: false
        }

        this.setEdit = this.setEdit.bind(this)
    }

    setEdit(edit) {
        this.setState({
            edit: edit
        })
    }

    render() {
        const { headline, headlineAddition, fieldName, currValues, currPriceValues, formValues, formPriceValues, settings, totalNumber, activeField, setActiveField } = this.props;

        return (
            <EditEventFormTypeWrapper headline={headline} headlineAddition={headlineAddition}>
                {settings.order.map(itemId => {
                    let fieldNameVar = fieldName;
                    if (itemId.includes('_other_fees')) fieldNameVar += '_other_fees';
                    const name = fieldNameVar + '.' + itemId
                    const namePrice = 'prices.' + name
                    const label = settings.items[itemId].info.name
                    const type = settings.items[itemId].info.input
                    let currValue = currValues[itemId];
                    if (typeof currValue === 'boolean') currValue *= 1;
                    const currPrice = currPriceValues[itemId];
                    let pro = false;
                    if (settings.items[itemId].info.pro && settings.items[itemId].info.pro == 1) pro = true;
                    const labelPro = pro ? (' (pro ' + (fieldName === 'visitors' ? 'Person)' : 'Saal)')) : '';

                    return (
                        <div key={name} className='price-item'>
                            <p className='text-small-regular'>{label + labelPro + ':'}</p>
                            <div className='price-item-row'>
                                <TextValueField
                                    name={name}
                                    label={type === 'number' ? 'Anzahl' : ''}
                                    type={type}
                                    withLineBreak={false}
                                    lineBreakInCurrentName={false}
                                    formValue={formValues[itemId]}
                                    currValue={currValues[itemId]}
                                    activeField={activeField}
                                    setActiveField={setActiveField}
                                />
                                <TextValueField
                                    name={namePrice}
                                    label="Preis"
                                    type="number"
                                    withLineBreak={false}
                                    lineBreakInCurrentName={false}
                                    formValue={formPriceValues[itemId]}
                                    currValue={currPrice}
                                    isPrice={true}
                                    activeField={activeField}
                                    setActiveField={setActiveField}
                                />
                                <p className='item-total'>
                                    <span className='text-small-regular'>{'= ' + formatPrice((currValue * currPrice * (pro ? totalNumber : 1))) + ' €'}</span>
                                </p>
                            </div>

                        </div>
                    )
                })}
            </EditEventFormTypeWrapper>
        )
    }
}

export default EditEventFormPriceType